import * as Notiflix from 'notiflix/dist/notiflix-3.2.8.min';
window.Notiflix = Notiflix